export const common = {
  nav: {
    home: 'HOME',
    about: 'ABOUT',
    services: 'SERVICES',
    contact: 'CONTACT'
  },
  footer: {
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Information',
    address: 'Address',
    addressValue: 'Gorkého 129/10, Bratislava – Old Town',
    email: 'Email',
    phone: 'Phone',
    copyright: 'All rights reserved.',
    poweredBy: 'Powered by Readdy'
  }
};
